import { API } from '../../../../api';
import { axiosInstance } from '../../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getLaneListEffectCancelToken = () => {};
export const getLaneListEffect = (data) => {
  getLaneListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLaneBy`,
    method: 'GET',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getLaneListEffectCancelToken = c;
    }),
  });
};

export const saveCreateUpdateLaneEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/PostSaveLane`,
    method: 'POST',
    data,
  });
};

export const getParameterTypeEffects = () => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetParameterType`,
    method: 'GET',
  });
};

export const getFieldDataTypeEffects = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetFieldDataType`,
    method: 'GET',
    params: data,
  });
};

export const getLaneListSearchEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLaneBy`,
    method: 'GET',
    params: data,
  });
};
